import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Icon, Progress, Popover, List } from 'antd';
import './styles.less';

function ScoringCircle(props) {
  const onHover = [];
  if (props.scoringProfile) {
    onHover.push({
      label: props.intl.formatMessage({ id: 'Component.Common.ScoringCircle.PublicProfile' }),
      score: props.publicScore,
      name: props.scoringProfile.name,
    });
  }

  if (props.privateScoringProfile) {
    onHover.push({
      label: props.intl.formatMessage({ id: 'Component.Common.ScoringCircle.PrivateProfile' }),
      score: props.privateScore,
      name: props.privateScoringProfile.name,
    });
  }

  return (
    <Popover
      className="hint"
      placement="topLeft"
      content={props.finalScore !== null &&
      <List
        dataSource={onHover}
        renderItem={c => (
          <List.Item className="circle-item">
            <span className="label">{c.label}:</span>
            <span className="name">{c.name}</span>
            <span className="score-label">
              ({props.intl.formatMessage({ id: 'Component.Common.ScoringCircle.ScoreLabel' })} {c.score})
            </span>
          </List.Item>
        )}
      />
      }
    >
      <div className="progress-wrap text-center">
        <Progress
          className={`progress-${props.finalScore}`}
          width={40}
          strokeWidth={8}
          type="circle"
          percent={props.finalScore * 10}
          format={() => props.finalScore || props.intl.formatMessage({ id: 'Common.NA' })}
        />
        {props.privateScore !== null &&
        <span className={props.privateScore !== null ? 'accent-el' : ''}>
          <Icon type="user" />
        </span>
        }
      </div>
    </Popover>
  );
}

const validateScore = (score) => {
  if (score === null) {
    return null;
  }

  if (Number.isInteger(score) === false) {
    throw new Error(`The score value must be integer or null. Actual value is ${score}`);
  }

  if (score < 0 || score > 10) {
    throw new Error('Score value must be between 0 and 10');
  }

  return null;
};

const scoringProfilePropType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
});

ScoringCircle.propTypes = {
  publicScore: (props) => {
    return validateScore(props.publicScore);
  },
  privateScore: (props) => {
    return validateScore(props.privateScore);
  },
  finalScore: (props) => {
    return validateScore(props.finalScore);
  },
  scoringProfile: scoringProfilePropType,
  privateScoringProfile: scoringProfilePropType,
};

export default injectIntl(ScoringCircle);



// WEBPACK FOOTER //
// ./src/components/common/ScoringCircle/index.js